"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainContent = void 0;
var _react = require("react");
var _Modal = require("../../Layout/Modal");
var _SliderLayout = require("../../Layout/SliderLayout");
var _useAudiencePickerProvider = require("../AudiencePicker/provider/useAudiencePickerProvider");
var _TaskManager = require("./TaskManager.provider");
var _carrouselItems = require("./carrouselItems");
var _useCurrentIndex2 = require("./hooks/useCurrentIndex");
var _useUnitData2 = require("./hooks/useUnitData");
var _hooks = require("../../hooks");
var _useMessages = require("./hooks/useMessages");
var _Preloader = require("../../UI/Preloader");
var _TaskManager2 = _interopRequireDefault(require("./TaskManager.styles"));
var _useItem2 = require("./hooks/useItem");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MainContent = function MainContent(props) {
  var environmentID = props.environmentID,
    audienceID = props.audienceID,
    itemID = props.itemID,
    taskID = props.taskID,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'popup' : _props$layout,
    onClose = props.onClose,
    onStatusChange = props.onStatusChange,
    itemLanguage = props.itemLanguage,
    kotarParams = props.kotarParams,
    minDate = props.minDate,
    maxDate = props.maxDate,
    _props$isChangeAudien = props.isChangeAudienceAfterSubmitEnabled,
    isChangeAudienceAfterSubmitEnabled = _props$isChangeAudien === void 0 ? false : _props$isChangeAudien,
    _props$isNoAudienceEn = props.isNoAudienceEnabled,
    isNoAudienceEnabled = _props$isNoAudienceEn === void 0 ? false : _props$isNoAudienceEn,
    _props$isAssignedTask = props.isAssignedTaskUrlEnabled,
    isAssignedTaskUrlEnabled = _props$isAssignedTask === void 0 ? true : _props$isAssignedTask,
    _props$isLearningActi = props.isLearningActivity,
    isLearningActivity = _props$isLearningActi === void 0 ? false : _props$isLearningActi,
    shareItemUrl = props.shareItemUrl,
    supportUrl = props.supportUrl,
    isNmm = props.isNmm;
  var _useSessionData = (0, _hooks.useSessionData)(),
    isSessionDataReady = _useSessionData.isSessionDataReady,
    userId = _useSessionData.userId;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    viewHeight = _useDeviceData.viewHeight;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var styles = (0, _TaskManager2.default)();
  var _useContext = (0, _react.useContext)(_TaskManager.TaskManagerContext),
    isPopupOpen = _useContext.isPopupOpen,
    setIsPopupOpen = _useContext.setIsPopupOpen,
    setIsChanged = _useContext.setIsChanged,
    task = _useContext.task,
    setShowReadOnlyMessageGroups = _useContext.setShowReadOnlyMessageGroups,
    readOnlyGroups = _useContext.readOnlyGroups,
    readOnlyStudents = _useContext.readOnlyStudents,
    selectedGroups = _useContext.selectedGroups,
    selectedStudents = _useContext.selectedStudents,
    isGroupsReadOnly = _useContext.isGroupsReadOnly,
    onCloseData = _useContext.onCloseData,
    isUnitDataLoading = _useContext.isUnitDataLoading,
    isTaskLoading = _useContext.isTaskLoading,
    isCloneItem = _useContext.isCloneItem,
    isSavingItem = _useContext.isSavingItem,
    getLabel = _useContext.getLabel;
  var handleChanged = function handleChanged() {
    setIsChanged(true);
  };
  var handleDisabledItemClick = function handleDisabledItemClick() {
    var message = null;
    if (task && !task.isReadOnly && task.cannotModifyMembers) {
      message = getLabel('message_groupsSelector_cant_remove');
      setShowReadOnlyMessageGroups(message);
    }
    return message;
  };
  var handleDeleteItem = function handleDeleteItem() {
    var message = null;
    if (task && !task.isReadOnly && task.cannotModifyMembers && isChangeAudienceAfterSubmitEnabled) {
      message = getLabel('message_remove_students_from_audience');
    }
    return message;
  };
  var handleClose = function handleClose() {
    setIsPopupOpen(false);
    if (onClose) {
      onClose(onCloseData);
    }
  };
  var audiencePickerProvider = (0, _useAudiencePickerProvider.useAudiencePickerProvider)({
    onChanged: handleChanged,
    onDisableItemClick: handleDisabledItemClick,
    onDeleteItem: handleDeleteItem,
    onClose: handleClose,
    isReadOnly: isGroupsReadOnly,
    readOnlyGroups: readOnlyGroups,
    readOnlyStudents: readOnlyStudents,
    selectedGroups: selectedGroups,
    selectedStudents: selectedStudents,
    // isEditGroupEnabled: isEditGroupEnabled,
    environmentID: environmentID,
    audienceID: audienceID,
    fullHeight: "calc(".concat(viewHeight + 'px', " - ").concat(pxToRem(62), ")")
  });
  var _useCurrentIndex = (0, _useCurrentIndex2.useCurrentIndex)(audiencePickerProvider, isNoAudienceEnabled, itemID, taskID, onStatusChange),
    getCurrentIndex = _useCurrentIndex.getCurrentIndex;
  var currentIndex = getCurrentIndex();
  var _useUnitData = (0, _useUnitData2.useUnitData)(),
    initUnitData = _useUnitData.initUnitData;
  (0, _react.useEffect)(function () {
    initUnitData();
  }, [initUnitData]);
  (0, _useMessages.useMessages)(); //todo: fix messages

  var _useItem = (0, _useItem2.useItem)(itemID, itemLanguage, environmentID, audienceID, taskID, kotarParams, minDate, maxDate, isChangeAudienceAfterSubmitEnabled, isLearningActivity),
    getItem = _useItem.getItem;
  (0, _react.useEffect)(function () {
    getItem();
  }, [getItem]);
  (0, _react.useEffect)(function () {
    if (layout === 'popup') {
      setIsPopupOpen(true);
    }
  }, [layout, setIsPopupOpen]);
  if (!(isSessionDataReady && userId)) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-TaskManager'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
      isOpen: isPopupOpen,
      isCloseFromOutsideEnabled: false,
      type: audiencePickerProvider.isErrorMessage || currentIndex === 9 ? 'alert' : currentIndex === 7 || currentIndex === 8 ? 'success' : undefined,
      layout: layout,
      onClose: handleClose,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SliderLayout.SliderLayout, {
        width: "100%",
        index: currentIndex,
        items: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.ItemSelect, _objectSpread({}, props)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Main, _objectSpread(_objectSpread({}, props), {}, {
          handleClose: handleClose,
          audiencePickerProvider: audiencePickerProvider
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Audience, {
          view: "groupsSelector",
          audiencePickerProvider: audiencePickerProvider
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Audience, {
          view: "studentsSelector",
          audiencePickerProvider: audiencePickerProvider
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Audience, {
          view: "createGroup",
          audiencePickerProvider: audiencePickerProvider
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Audience, {
          view: "groupEdit",
          audiencePickerProvider: audiencePickerProvider
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.EditTask, {
          isLearningActivity: isLearningActivity
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.SavingTask, {
          isAssignedTaskUrlEnabled: isAssignedTaskUrlEnabled,
          handleClose: handleClose,
          audiencePickerProvider: audiencePickerProvider
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.ShareTask, {
          isLearningActivity: isLearningActivity,
          shareItemUrl: shareItemUrl,
          handleClose: handleClose
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Error, _objectSpread(_objectSpread({}, props), {}, {
          handleClose: handleClose
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Alert, {
          type: "updateTaskTypeAfterExamStart"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Alert, {
          type: "reSubmitTaskAfterTaskTypeChanged"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Alert, {
          type: "noAudience",
          handleClose: handleClose,
          isNmm: isNmm,
          supportUrl: supportUrl
        })],
        children: (isUnitDataLoading || isTaskLoading || isCloneItem || isSavingItem || !audiencePickerProvider.isAudiencePickerProviderReady) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Preloader.Preloader, {
          type: "over",
          width: 300
        })
      })
    })
  });
};
exports.MainContent = MainContent;